/* eslint-disable @typescript-eslint/no-explicit-any */
export type ActionError = any;
